// This is the javascript entrypoint for the recently-viewed section.
// This file and all its inclusions will be processed through esbuild

import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/init-observer';

theme.recentlyViewedIds = [];

if (theme.config.hasLocalStorage) {
  const recentIds = window.localStorage.getItem("recently-viewed");
  if (recentIds && typeof recentIds !== undefined) {
    theme.recentlyViewedIds = JSON.parse(recentIds);
  }
}

class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.initialized = false;
    this.container = this;
    this.sectionId = this.container.getAttribute('data-section-id');
    this.maxProducts = this.container.getAttribute('data-max-products');
    this.itemBorderColor = this.container.getAttribute('data-border');
    this.itemBackgroundColor = this.container.getAttribute('data-background');

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600
    });

    document.dispatchEvent(new CustomEvent('recently-viewed:loaded', {
      detail: {
        sectionId: this.sectionId
      }
    }));
  }

  static addIdToRecentlyViewed(id) {
    if (!id) return;

    // Remove current product if already in recently viewed array
    if (theme.recentlyViewedIds.includes(id)) {
      theme.recentlyViewedIds.splice(theme.recentlyViewedIds.indexOf(id), 1);
    }

    // Add id to array
    theme.recentlyViewedIds.unshift(id);

    if (theme.config.hasLocalStorage) {
      window.localStorage.setItem('recently-viewed', JSON.stringify(theme.recentlyViewedIds));
    }
  }

  init() {
    if (this.initialized) {
      return;
    }

    this.initialized = true;

    // Stop if no data
    if (!theme.recentlyViewedIds.length) {
      this.container.classList.add('hide');
      return;
    }

    this.outputContainer = this.container.querySelector(`#RecentlyViewed-${this.sectionId}`);
    const currentId = this.container.getAttribute('data-product-id');

    let url = `${theme.routes.search}?view=recently-viewed&type=product&q=`;

    let products = '';
    let i = 0;
    theme.recentlyViewedIds.forEach((val) => {
      // Skip current product
      if (val === currentId) {
        return;
      }

      // Stop at max
      if (i >= this.maxProducts) {
        return;
      }

      products += `id:${val} OR `;
      i++;
    });

    url = url + encodeURIComponent(products);

    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const items = html.querySelectorAll('.grid-product');
      const count = items.length;

      if (count > 0) {
        const results = html.querySelector('.product-grid');

        if(this.itemBorderColor != '' || this.itemBackgroundColor != '') {
          Array.from(items).forEach(function(item){
            if(this.itemBorderColor != '') {
              let gridBox = item.querySelector('.product-grid-item');
              gridBox.style.border = '1px solid ' + this.itemBorderColor;
            }
            if(this.itemBackgroundColor != '') {
              let metaBox = item.querySelector('.grid-item__meta');
              metaBox.style.background = this.itemBackgroundColor;
            }
          }, this);
        }
        
        this.outputContainer.append(results);
      } else {
        this.container.classList.add('hide');
      }
    }).catch(e => {
      console.error(e);
    });
  }

  disconnectedCallback() {
    this.initialized = false;
  }
}

customElements.define('recently-viewed', RecentlyViewed);

export { RecentlyViewed };
